import { useEffect } from 'react';
import { cleanUrl } from '../utils/validation';

// Helper function to get a cookie by name
export const getCookie = (name: string): string => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop()?.split(';').shift() || '';
  }
  return '';
};

// All cookies are set server-side, client only reads them

/**
 * Hook to initialize tracking data
 * All cookies are set server-side, this just ensures tracking is initialized
 */
export const useTrackingData = (): void => {
  useEffect(() => {
    // All cookies are set server-side, no client-side cookie setting needed
    // This effect just ensures the hook is called for any future initialization needs
  }, []);
};

/**
 * Gets all tracking data for a lead submission - ONLY from server-side cookies
 * All cookies are set by server-side tracking system
 * URLs are cleaned to remove encoding artifacts
 */
export const getTrackingData = (additionalData: Record<string, string> = {}): Record<string, string> => {
  return {
    _sdid: getCookie('_sdid'),
    referring_url: cleanUrl(getCookie('referring_url')),
    browser: getCookie('browser'),
    device_category: getCookie('device_category'),
    initial_visit_timestamp: getCookie('initial_visit_timestamp'),
    utm_source: getCookie('utm_source'),
    utm_medium: getCookie('utm_medium'),
    utm_campaign: getCookie('utm_campaign'),
    utm_content: getCookie('utm_content'),
    utm_term: getCookie('utm_term'),
    gclid: getCookie('gclid'),
    fbclid: getCookie('fbclid'),
    gbraid: getCookie('gbraid'),
    placement: getCookie('placement'),
    landing_page_url: cleanUrl(getCookie('landing_page_url')),
    leadPlatform: getCookie('leadPlatform'), // No fallback - comes from server-side
    FPIDP: getCookie('FPIDP'),
    suid: getCookie('suid'),
    stape: getCookie('stape'),
    ...additionalData
  };
};

export default useTrackingData; 